export default {"src":"https://images-cdn.curipod.com/d-f267caa1/_next/static/media/common_sense_media.9c180185.svg","height":123,"width":300};